import { constants as insightsConstants } from 'mage-insights'
import { useDispatch } from 'react-redux'

export default function useGoogleAnalytics({ category, action, label }) {
  const dispatch = useDispatch()

  return extraData =>
    dispatch({
      type: 'EDUCATION_INSIGHTS_TRACKING',
      meta: {
        [insightsConstants.INSIGHTS_EVENT]: {
          category,
          action,
          label,
          ...extraData
        }
      }
    })
}
